<script>
  import { notificationState, removeToast } from '../../lib/stores/notifications.svelte.js';

  const toasts = $derived(notificationState.toasts);

  // Icon + color config per type
  const TYPE_CONFIG = {
    trade: { color: '#22c55e', bg: '#f0fdf4', border: '#bbf7d0' },
    considering: { color: '#3b82f6', bg: '#eff6ff', border: '#bfdbfe' },
    suggested: { color: '#f59e0b', bg: '#fffbeb', border: '#fde68a' },
    removed: { color: '#6b7280', bg: '#f9fafb', border: '#e5e7eb' },
    info: { color: '#6b7280', bg: '#f9fafb', border: '#e5e7eb' },
  };

  function getConfig(type) {
    return TYPE_CONFIG[type] || TYPE_CONFIG.info;
  }
</script>

{#if toasts.length > 0}
  <div class="toast-container">
    {#each toasts as toast (toast.id)}
      <!-- style: directives apply in source order: the border-color shorthand must
           precede border-left-color or it wipes the 4px type-colored accent. -->
      <!-- svelte-ignore a11y_click_events_have_key_events -->
      <!-- svelte-ignore a11y_no_static_element_interactions -->
      <div
        class="toast"
        style:border-color={getConfig(toast.type).border}
        style:border-left-color={getConfig(toast.type).color}
        style:background-color={getConfig(toast.type).bg}
        onclick={() => removeToast(toast.id)}
      >
        <div class="toast-icon" style:background-color={getConfig(toast.type).color}>
          {#if toast.type === 'trade'}
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg
            >
          {:else if toast.type === 'considering'}
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              ><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle
                cx="12"
                cy="12"
                r="3"
              ></circle></svg
            >
          {:else if toast.type === 'suggested'}
            <span class="toast-icon-text">?</span>
          {:else}
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line></svg
            >
          {/if}
        </div>
        <div class="toast-body">
          <div class="toast-message">{toast.message}</div>
          {#if toast.subtitle}
            <div class="toast-subtitle">{toast.subtitle}</div>
          {/if}
        </div>
      </div>
    {/each}
  </div>
{/if}

<style>
  .toast-container {
    position: fixed;
    top: 1rem;
    right: 1rem;
    z-index: 10001;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    pointer-events: none;
    max-width: 320px;
  }

  .toast {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    padding: 0.6rem 0.75rem;
    border-radius: 8px;
    border: 1px solid;
    border-left-width: 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    pointer-events: auto;
    cursor: pointer;
    animation: toast-slide-in 0.25s ease-out;
    transition:
      opacity 0.2s,
      transform 0.2s;
  }

  .toast:hover {
    opacity: 0.85;
  }

  @keyframes toast-slide-in {
    from {
      opacity: 0;
      transform: translateX(100%);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .toast-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 1px;
  }

  .toast-icon svg {
    width: 12px;
    height: 12px;
  }

  .toast-icon-text {
    color: white;
    font-weight: 700;
    font-size: 11px;
    line-height: 1;
  }

  .toast-body {
    flex: 1;
    min-width: 0;
  }

  .toast-message {
    font-size: 0.8rem;
    font-weight: 600;
    color: #1f2937;
    line-height: 1.3;
  }

  .toast-subtitle {
    font-size: 0.7rem;
    color: #6b7280;
    margin-top: 0.1rem;
  }

  @media (max-width: 768px) {
    .toast-container {
      top: 0.5rem;
      right: 0.5rem;
      left: 0.5rem;
      max-width: none;
    }
  }
</style>
